// Examen blanc — Grille type permis B (31 critères officiels)
// Contenu natif extrait du HTML legacy CFCS. Marque retirée (PRD).

export const EXAMEN_GRILLE_31 = [
  { n: 1,  cat: 'Installation & contrôle véhicule', label: 'Installation au poste de conduite et sécurité' },
  { n: 2,  cat: 'Installation & contrôle véhicule', label: 'Mise en route, démarrage et arrêt du véhicule' },
  { n: 3,  cat: 'Installation & contrôle véhicule', label: 'Utilisation des commandes (pédales, volant, boîte…)' },
  { n: 4,  cat: 'Maîtrise du véhicule',            label: 'Tenue de trajectoire / conduite en ligne droite' },
  { n: 5,  cat: 'Maîtrise du véhicule',            label: 'Gestion de la vitesse (adaptation aux circonstances)' },
  { n: 6,  cat: 'Maîtrise du véhicule',            label: 'Respect des distances de sécurité' },
  { n: 7,  cat: 'Observation & prise d\'information', label: 'Observation globale (rétroviseurs, regard lointain)' },
  { n: 8,  cat: 'Observation & prise d\'information', label: 'Contrôle des angles morts' },
  { n: 9,  cat: 'Signalisation & règles',          label: 'Respect de la signalisation verticale (panneaux)' },
  { n: 10, cat: 'Signalisation & règles',          label: 'Respect de la signalisation horizontale (marquages)' },
  { n: 11, cat: 'Signalisation & règles',          label: 'Respect des feux tricolores' },
  { n: 12, cat: 'Intersections & priorités',       label: 'Gestion des intersections simples' },
  { n: 13, cat: 'Intersections & priorités',       label: 'Gestion des STOP et Cédez le passage' },
  { n: 14, cat: 'Intersections & priorités',       label: 'Gestion des giratoires' },
  { n: 15, cat: 'Manœuvres & changements',         label: 'Changements de direction (placement, clignotants)' },
  { n: 16, cat: 'Manœuvres & changements',         label: 'Changements de voie / dépassements' },
  { n: 17, cat: 'Partage de la route',             label: 'Partage de la chaussée (cycles, piétons, usagers vulnérables)' },
  { n: 18, cat: 'Partage de la route',             label: 'Franchissement des passages piétons' },
  { n: 19, cat: 'Environnements de conduite',      label: 'Conduite en agglomération' },
  { n: 20, cat: 'Environnements de conduite',      label: 'Conduite hors agglomération' },
  { n: 21, cat: 'Environnements de conduite',      label: 'Positionnement sur chaussées à plusieurs voies' },
  { n: 22, cat: 'Adaptation & imprévus',           label: 'Gestion des situations imprévues / dangers' },
  { n: 23, cat: 'Adaptation & imprévus',           label: 'Manœuvre imposée (stationnement, marche arrière…)' },
  { n: 24, cat: 'Adaptation & imprévus',           label: 'Utilisation des commandes en situation complexe' },
  { n: 25, cat: 'Autonomie & comportements',       label: 'Autonomie sur un itinéraire donné' },
  { n: 26, cat: 'Autonomie & comportements',       label: 'Conduite économique et respectueuse de l\'environnement' },
  { n: 27, cat: 'Autonomie & comportements',       label: 'Respect des autres usagers (courtoisie, communication)' },
  { n: 28, cat: 'Autonomie & comportements',       label: 'Attitude / gestion du stress' },
  { n: 29, cat: 'Synthèse globale',                label: 'Sécurité globale des décisions' },
  { n: 30, cat: 'Synthèse globale',                label: 'Aptitude à conduire seul en sécurité' },
  { n: 31, cat: 'Synthèse globale',                label: 'Respect global du Code de la route' },
];

export const EXAMEN_CATEGORIES = [
  "Installation & contrôle véhicule",
  "Maîtrise du véhicule",
  "Observation & prise d'information",
  "Signalisation & règles",
  "Intersections & priorités",
  "Manœuvres & changements",
  "Partage de la route",
  "Environnements de conduite",
  "Adaptation & imprévus",
  "Autonomie & comportements",
  "Synthèse globale",
];

// Règles d'évaluation (extraites verbatim de la fonction calc())
export const EXAMEN_REGLES = {
  ok_ratio_admis: 80,   // ≥80% des critères OK → avis favorable
  ok_ratio_reserve: 60, // 60-79% → avis réservé
  // <60% ou éliminatoire = Ajourné
};

export const EXAMEN_AVIS = {
  favorable: 'Avis favorable — niveau proche de l\'examen',
  reserve:   'Avis réservé — des points restent à travailler',
  ajourne:   'Ajourné — niveau insuffisant pour l\'examen',
  elim:      'Ajourné — faute éliminatoire',
};
